import { ondemandEndpoint } from '../services/endpoints';

export const createOnDemand = async (formValues) => {
  try {
    let serviceResponse;

    const response = await fetch(ondemandEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formValues),
    });
    const parsedResponse = await response.json();

    if (response.status === 201) {
      serviceResponse = { success: true, data: parsedResponse };
    } else {
      serviceResponse = { success: false, data: parsedResponse };
    }

    return serviceResponse;
  } catch (error) {
    console.error('Error creating onDemand: ', error);
    return {
      success: false,
      data: error,
    };
  }
};

export default createOnDemand;
